import React, { useState, useEffect } from 'react'
import { Query, Mutation } from 'react-apollo'
import _ from 'lodash'
import {
  Div, P, Loading,
} from 'konsys-ui'
import { useMutation, useQuery } from '@apollo/react-hooks'
import { CREATE_PURCHASE_REQUISITION, UPDATE_PURCHASE_REQUISITION } from '../../../constants/graph/mutation'
import { PURCHASE_REQUISITION_INFO, TIRE_SERIAL_NUMBER_INFO } from '../../../constants/graph/query'
import detailType from '../util-functions'
import { detailMode } from '../constants'
import { ActionBar } from '../../../components/purchase-requisition-components'

const Index = ({ props }) => {
  const isAddMode = props.match.params.mode.toUpperCase() === detailMode.ADD
  const isViewMode = props.match.params.mode.toUpperCase() === detailMode.VIEW
  const [doAction, { loading: mutationLoading }] = useMutation(isAddMode ? CREATE_PURCHASE_REQUISITION : UPDATE_PURCHASE_REQUISITION)
  const {
    loading, data, error, refetch,
  } = useQuery(PURCHASE_REQUISITION_INFO, { skip: isAddMode, variables: { id: props.match.params.id } })

  const [mutationVariables, setMutationVariables] = useState({
    Items: [{
      id: 0, inventoryOptionId: undefined, quantity: '',
    }],
  })

  const onChangeHandler = (id, value) => {
    if (id === 'price') {
      setMutationVariables({
        ...mutationVariables,
        [id]: parseFloat(value),
      })
    } else {
      setMutationVariables({
        ...mutationVariables,
        [id]: value,
      })
    }
  }

  useEffect(() => {
    if (!isAddMode && !loading) {
      console.info(data)
      setMutationVariables({
        ...mutationVariables,
        id: data.PurchaseRequestInfo.id,
        deadlineDate: data.PurchaseRequestInfo.deadlineDate,
        remark: data.PurchaseRequestInfo.remark,
        repairId: data.PurchaseRequestInfo.repairId,
        supplierId: data.PurchaseRequestInfo.supplierId,
        department: data.PurchaseRequestInfo.department,
        // Items: _.pick(data.PurchaseRequestInfo.Items, ['inventoryOptionId', 'quantity', 'price']),
        Items: data.PurchaseRequestInfo.Items.map(v => ({
          id: v.id,
          inventoryOptionId: v.inventoryOptionId,
          sku: v.InventoryOption.inventory.sku,
          productName: v.InventoryOption.inventory.productName,
          quantity: v.quantity,
          orderedQuantity: v.orderedQuantity,
          totalAmount: _.find(v.InventoryOption.stockLocation, o => o.warehouse.warehouseCode === '00001').quantity,
          oldBuyPrice: v.InventoryOption.buyPrice || 0,
          price: v.price,
          remark: v.remark,
        })),
      })
    }
  }, [loading])

  useEffect(() => {
    console.info('log ja')
  }, [mutationVariables.supplierId])

  useEffect(() => {
    console.info('log ja', mutationVariables.Items)
  }, [mutationVariables.Items])

  // if (!isAddMode && loading && _.isEmpty(data)) return <Loading center='true' />
  if (!isAddMode && _.isEmpty(data)) return <Loading center='true' />
  if (!isAddMode && error) return <P>เกิดข้อผิดพลาด</P>
  return (
    <Div display='flex' flexDirection='column'>
      {/* ================== Data section ================== */}
      {
        isAddMode
          ? detailType(props.match.params, onChangeHandler, mutationVariables, setMutationVariables)
          : <Div>
            {
              detailType(props.match.params, onChangeHandler, mutationVariables, setMutationVariables, data.PurchaseRequestInfo) // argument mode
            }
          </Div>
      }
      {/* ================== Footer section ================== */}
      {
        !isViewMode
          ? <ActionBar
            loading={mutationLoading}
            disabled={_.isUndefined(mutationVariables.deadlineDate) || _.isEmpty(mutationVariables.deadlineDate)
              || _.size(_.filter(mutationVariables.Items, o => _.isUndefined(o.inventoryOptionId) || _.isUndefined(o.quantity))) > 0}
            isAddMode={isAddMode}
            isViewMode={isViewMode}
            doAction={doAction}
            mutationVariables={{ ...mutationVariables }}
            props={props}
            refetch={refetch}
            setMutationVariables={setMutationVariables}
          />
          : <ActionBar
            isAddMode={isAddMode}
            isViewMode={isViewMode}
            props={props}
            mutationVariables={{ ...mutationVariables }}
            refetch={refetch}
            setMutationVariables={setMutationVariables}
          />
      }
    </Div>
  )
}

export default Index
export { Index }
